<template>

    <Head>
        <title v-if="newSeriesData">{{ $t('meta.seriesdetail_title', { name: newSeriesData.name }) }}</title>
        <meta v-if="newSeriesData" name="title"
            :content="$t('meta.seriesdetail_title', { name: newSeriesData.name })" />
        <meta v-if="newSeriesData" name="description"
            :content="$t('meta.seriesdetail_description', { name: newSeriesData.name })" />
    </Head>
    <div class="main" v-if="seriesData">
        <div v-if="!isPremium && false" class="ad-container">
            <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2323891108"
                data-ad-format="auto" :data-full-width-responsive="true">
            </Adsense>
        </div>
        <div id="container">
            <!--HERO SECTİON-->
            <div id="introduction">
                <div class="title-container">
                    <p>{{ newSeriesData.name }}</p>
                </div>
                <img class="image" :src="newSeriesData.urlLarge" alt="">
                <img class="ellipse" src="../assets/SeriesDetail/ellipse1.svg" alt="">
                <div class="content-card">
                    <div class="inner-card">
                        <span class="season-count"> {{ $t("series_detail.season_count") }} {{
                            newSeriesData.seasons_length }}</span>
                        <span class="difficulty-level"
                            :class="[(newSeriesData.difficulty == 'Çok Kolay' ? 'very_easy_level' : ''), (newSeriesData.difficulty == 'Kolay' ? 'easy_level' : ''), (newSeriesData.difficulty == 'Orta' ? 'mid_level' : ''), (newSeriesData.difficulty == 'Zor' ? 'difficult_level' : '')]">
                            {{ $store.getters.getLocaleDifficulty(newSeriesData.difficulty) }}</span>
                    </div>
                    <p v-if="$i18n.locale == 'tr'" class="description">{{ newSeriesData.description }}</p>
                    <p v-else class="description">{{ newSeriesData.metaDescription }}</p>
                </div>
            </div>
            <!--HERO SECTİON-->
            <div v-if="!isPremium && false" class="ad-container-yatay">
                <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="1450636360" data-ad-format="auto"
                    :data-full-width-responsive="true">
                </Adsense>
            </div>
            <!--SEASOn AND EPISODE SELECTION SECTİON-->
            <div v-if="!newSeriesData.isPremium || isPremium" class="selection">
                <div @click="seasonSelectionToggler()" class="selection-bar">
                    <div class="text">
                        <div class="title">{{ $t("series_detail.season_selection") }}</div>
                        <div class="selected">{{ selectedSeason }}</div>
                    </div>
                    <div class="icon">
                        <img src="../assets/SeriesDetail/select-box-arrow.svg" alt="">
                    </div>
                </div>
                <Transition name="fade">
                    <div v-show="seasonSelectionToggle" class="content-list">
                        <div @click="changeSeason(seasonIndex)" v-for="seasonIndex in newSeriesData.seasons_length"
                            class="content-list-element">
                            {{ $t("series_detail.season_index") }} {{ seasonIndex }}
                        </div>
                    </div>
                </Transition>

                <div @click="episodeSelectionToggler()" class="selection-bar">
                    <div class="text">
                        <Loading v-if="isLoading" />
                        <div v-else class="title">{{ $t("series_detail.episode_selection") }}
                        </div>

                        <div class="selected">{{ selectedEpisode.name }}</div>
                    </div>
                    <div class="icon">
                        <img src="../assets/SeriesDetail/select-box-arrow.svg" alt="">
                    </div>
                </div>
                <Transition name="fade">
                    <div v-show="episodeSelectionToggle" class="content-list">
                        <div @click="changeEpisode(episode)" v-for="episode in episodeIdList.length"
                            class="content-list-element">
                            {{ $t("series_detail.episode_index") }} {{ episode }}
                        </div>
                    </div>
                </Transition>
                <WordListComponent v-if="selectedEpisode.words.length" :wordList="selectedEpisode.words"
                    :key="MeanLanguageType">
                </WordListComponent>
            </div>
            <ProWall v-else>
            </ProWall>
            <!--SEASOn AND EPISODE SELECTION SECTİON-->
        </div>
        <div v-if="!isPremium && false" class="ad-container">
            <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2323891108"
                data-ad-format="auto" :data-full-width-responsive="true">
            </Adsense>
        </div>
    </div>
    <Loading v-else style="min-height: 100vh" />
</template>

<script>
import axios from "axios"
import WordListComponent from "../components/Shared/WordListComponent";
import ProWall from "../components/Premium/ProWall"

export default {
    components: {
        WordListComponent,
        ProWall
    },

    data() {
        return {
            seriesList: [],
            selectedSeason: "",
            selectedEpisode: { name: "", words: [] },
            episodeIdList: [],
            seasonSelectionToggle: false,
            episodeSelectionToggle: false,
            isLoading: false
        };
    },
    created() {
        this.$store.commit('setEditOption', false)

    },
    methods: {
        changeSeason(seasonIndex) {
            // clean data
            this.selectedEpisode = { name: "", words: [] }


            // prepare data
            this.selectedSeason = this.$t("series_detail.season_index") + " " + seasonIndex
            this.episodeIdList = this.seriesData.seasons[seasonIndex - 1].episodeIdList


            this.seasonSelectionToggle = !this.seasonSelectionToggle
        },

        changeEpisode(episode_index) {
            this.isLoading = true
            this.removedPhrases = []
            this.episodeSelectionToggle = !this.episodeSelectionToggle
            axios.get('/api/WordList/GetWordListV2', { params: { type: 3, id: this.episodeIdList[episode_index - 1], MeanLanguageType: this.MeanLanguageType } }).then((response) => {
                response.data.name = this.$t("series_detail.episode_index") + " " + episode_index
                this.selectedEpisode = response.data
                this.quizList = response.data.words;
                // kaldığım yerden devam et 
                this.$store.commit("set_history_title", response.data.name)
                this.isLoading = false

            })

        },

        seasonSelectionToggler() {
            this.seasonSelectionToggle = !this.seasonSelectionToggle
        },

        episodeSelectionToggler() {
            this.episodeSelectionToggle = !this.episodeSelectionToggle
        }

    },
    computed: {
        seriesData() {
            this.seriesList = this.$store.getters.getDOData.data.series
            var filteredData = this.seriesList.filter((object) => {
                return object.combinedUrl == this.$route.params.url;
            });
            // clean data
            this.episodeIdList = []
            this.selectedEpisode = { name: "", words: [] }

            return filteredData[0]
        },
        newSeriesData() {
            if (this.seriesData) {
                return {
                    ...this.seriesData,
                    seasons_length: this.seriesData.seasons.length,
                    urlLarge: this.seriesData.urlLarge && require(`../assets${this.seriesData.urlLarge}`)
                }

            }
        },
        isPremium() {
            return this.$store.getters.getUserData.isPremium
        },
        MeanLanguageType() {
            if (this.$i18n.locale == "en") {
                return 1;
            } else if (this.$i18n.locale == "es") {
                return 3;
            } else {
                return 2
            }
        },

    },

}
</script>

<style scoped>
@charset "UTF-8";

.main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    -webkit-justify-content: center;
    gap: 24px;
    min-height: 100vh;
    width: 100%;
    padding-bottom: 48px;
}

#container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    min-width: 900px;
    -webkit-justify-content: center;
    -webkit-align-items: center;
}

#introduction {
    display: flex;
    flex-direction: column;
    height: fit-content;
    gap: 192px;
    position: relative;
    width: 100%;
}

#introduction .title-container {
    width: 572px;
    min-height: 286px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    background: var(--Primary, #8887C6);
}

#introduction .title-container p {
    margin: 0;
    color: var(--OnPrimary, #F8F8F8);
    text-align: center;
    font-family: Urbanist;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}

#introduction .image {
    width: fit-content;
    height: fit-content;
    /* width: 608.482px;
    height: 437.234px; */
    border-radius: 24px;
    position: absolute;
    right: 66px;
    top: 100px;
    z-index: 4;

}

#introduction img.ellipse {
    width: 223px;
    height: 215px;
    position: absolute;
    right: 320px;
    top: 330px;
}

.content-card {
    width: 672px;
    height: fit-content;
    border-radius: 24px;
    background: #FFF;
    box-shadow: 0px 4px 20px 5px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 48px;
    z-index: 3;
}

.content-card .description {
    color: var(--Black-Gray, #696969);
    /* WEB/Body Medium */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.content-card .inner-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.content-card .inner-card .season-count {
    color: var(--Secondary, #DC8989);
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-bottom: 3px solid #B7B7B7;
}

.content-card .inner-card .difficulty-level {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    border-radius: 10px;
    color: var(--Gray-6, #F2F2F2);
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    cursor: context-menu;
    margin-right: 170px;
}

.very_easy_level {
    color: var(--Lightest-Gray, #FBFBFB);
    background: var(--Green---Success, #9CD189);
}

.easy_level {
    color: var(--Lightest-Gray, #FBFBFB);
    background: var(--Green---Success, #9CD189);
}

.mid_level {
    color: var(--Lightest-Gray, #FBFBFB);
    background: var(--Primary, #8887C6);

}

.difficult_level {
    color: var(--Lightest-Gray, #FBFBFB);
    background: var(--Secondary, #DC8989);

}

.selection {
    display: flex;
    flex-direction: column;
    width: 95%;
    gap: 48px;
    margin-top: 96px;
}

.selection .selection-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    width: 100%;
    height: 96px;
    padding: 24px 48px;
    cursor: pointer;

}

.selection .selection-bar .text {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.selection .selection-bar .text .title {
    color: var(--Black-Gray, #696969);
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    /* 90% */
}

.selection .selection-bar .text .selected {
    color: var(--Primary, #8887C6);
    /* WEB/Label Large */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.content-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    margin-top: 0px;
    transition: max-height 0.9s ease-out;
}

.content-list-element {
    border-radius: 8px;
    background: var(--Lightest-Gray, #FBFBFB);
    /* Secondary Shadow */
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    width: 90%;
    max-width: 672px;
    height: 48px;
    padding: 16px 24px;
    color: var(--Primary, #8887C6);
    /* WEB/Label Medium */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    cursor: pointer;

}

@media (max-width: 600px) {
    .content-list-element {
        font-size: 12px;
    }

    .selection .selection-bar .text .selected {
        font-size: 12px;
    }

    .selection .selection-bar .text .title {
        font-size: 16px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@media (max-width: 1300px) {
    .main {
        flex-direction: column;
    }

    #container {
        min-width: 90%;
    }

    .left-side-bar,
    .right-side-bar {
        position: relative
    }

    #introduction {
        margin-top: 50px;
    }

    #introduction .title-container {
        width: 288px;
        min-height: 148px;
        border-radius: 16px;
        font-size: 22px;
        align-self: center;
        justify-self: center;


    }

    #introduction .title-container p {
        font-size: 22px;
    }

    #introduction img.ellipse {
        display: none;
    }

    #introduction .image {
        width: 291px !important;
        right: 0px !important;
        top: 120px !important;

    }

    .content-card {
        width: 312px !important;
        align-self: center !important;
        position: relative;
        z-index: 4;
    }



    .content-card .inner-card .season-count {
        font-size: 14px;
    }

    .content-card .inner-card .difficulty-level {
        padding: 4px 8px;
        font-size: 10px !important;
        margin-right: 0px;
    }
}
</style>